module.exports = __webpack_public_path__ + "static/media/poo.9622b5e5.svg";